/**
 * Animations Module
 * Handles scroll-based animations and transitions
 */

import { $$, addClass } from '../utils/dom.js';
import { CONFIG, SELECTORS } from '../config/constants.js';

export class ScrollAnimations {
    constructor() {
        this.observerOptions = {
            threshold: 0.1,
            rootMargin: `0px 0px -${CONFIG.ANIMATION.SCROLL_OFFSET}px 0px`
        };

        this.observer = null;
        this.init();
    }

    init() {
        this.createObserver();
        this.observeElements();
    }

    /**
     * Create Intersection Observer
     */
    createObserver() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, this.observerOptions);
    }

    /**
     * Observe feature blocks
     */
    observeElements() {
        // Observe feature blocks
        const featureBlocks = $$(SELECTORS.FEATURE_BLOCKS);
        featureBlocks.forEach((block, index) => {
            this.prepareElement(block, {
                delay: index * (CONFIG.ANIMATION.STAGGER_DELAY / 1000),
                translateY: '30px'
            });
            this.observer.observe(block);
        });

        // Observe FAQ items
        const faqItems = $$('.faq-item');
        faqItems.forEach((item, index) => {
            this.prepareElement(item, {
                delay: index * 0.08,
                translateY: '20px',
                duration: 0.5
            });
            this.observer.observe(item);
        });
    }

    /**
     * Prepare element for animation
     * @param {Element} element - Element to prepare
     * @param {Object} options - Animation options
     */
    prepareElement(element, options = {}) {
        const {
            delay = 0,
            translateY = '20px',
            duration = 0.6
        } = options;

        element.style.opacity = '0';
        element.style.transform = `translateY(${translateY})`;
        element.style.transition = `all ${duration}s ease ${delay}s`;
    }

    /**
     * Disconnect observer
     */
    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
